/* unplugin-vue-components disabled */import script from "./Wyrz.vue?vue&type=script&lang=ts&setup=true"
export * from "./Wyrz.vue?vue&type=script&lang=ts&setup=true"

import "./Wyrz.vue?vue&type=style&index=0&id=f017bfa8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f017bfa8"]])

export default __exports__